export const REDUX_NAMESPACE = 'TEXT';

export const FONT_SIZE_UNDO_REDO_GROUP = Symbol();
export const TEXT_STRING_UPDATE_GROUP = Symbol();
